import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=8720a144"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports